"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconSoundHigh = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.493 4.116l-5 3.999H.564a.516.516 0 00-.516.516V14.8l.005.07c.034.252.25.446.51.446h3.932l4.999 4c.338.27.838.03.838-.403V4.519c0-.433-.5-.673-.838-.403zm-.194 1.476v12.246l-4.302-3.442-.057-.04a.516.516 0 00-.265-.072H1.08V9.146h3.596c.117 0 .23-.04.322-.113L9.3 5.592zm7.424-.192a10.37 10.37 0 010 13.275.662.662 0 11-1.017-.847 9.047 9.047 0 000-11.58.662.662 0 011.017-.848z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.837 2.225a14.784 14.784 0 010 19.552.662.662 0 01-.993-.876 13.46 13.46 0 000-17.8.662.662 0 01.993-.876zm-6.219 6.33a5.958 5.958 0 010 6.901.662.662 0 01-1.08-.767 4.634 4.634 0 000-5.367.662.662 0 011.08-.767z",
    fill: "currentColor"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconSoundHigh, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;